import { render, staticRenderFns } from "./Xline.vue?vue&type=template&id=065c03cf&scoped=true"
import script from "./Xline.vue?vue&type=script&lang=js"
export * from "./Xline.vue?vue&type=script&lang=js"
import style0 from "./Xline.vue?vue&type=style&index=0&id=065c03cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c03cf",
  null
  
)

export default component.exports